export default "__VITE_ASSET__DLIqsC_U__"